import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import { useQuery } from '@tanstack/react-query';
import type { IPromoCodeStats, IPromoCodeUsage } from '@/interfaces';
import type { Paginated } from '@/lib/interface';
import routes from '@/lib/routes';

export const useRequestGetPromoCodeStats = (id?: string) => {
	const { isFetching, data } = useQuery({
		queryKey: [routes.api.promoCodes.base, id, 'stats'],
		enabled: !!id,
		queryFn: () => apiClient.get<IPromoCodeStats>(routes.api.promoCodes.stats(id as string)).then(handleApiResponse),
	});

	return { stats: data as IPromoCodeStats | undefined, isLoading: isFetching && !data };
};

export const useRequestGetPromoCodeUsages = (id?: string, page = 1) => {
	const { isFetching, data } = useQuery({
		queryKey: [routes.api.promoCodes.base, id, 'usages', page],
		enabled: !!id,
		queryFn: () =>
			apiClient
				.get<Paginated<IPromoCodeUsage>>(routes.api.promoCodes.usages(id as string), { page, limit: 10 })
				.then(handleApiResponse),
	});

	return { usages: data as Paginated<IPromoCodeUsage> | undefined, isLoading: isFetching && !data };
};
